import type { FC } from 'react';
import { useSelector } from 'react-redux';
import type { FormItemProps, SelectProps } from 'antd';
import i18n from 'i18next';

import type { RootState } from '@/redux/RootReducer';

import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetNonLCCApprovers } from '../../hooks';

interface ShipmentNonLCCApproversSelectProps
  extends Pick<FormItemProps, 'rules' | 'name'>,
    Pick<SelectProps, 'placeholder'> {
  label?: string;
  editMode?: boolean;
  margin?: string;
  tooltip?: boolean;
  isDefault?: boolean;
  disableValidation?: boolean;
  onChange?: (value: unknown) => void;
  disableDefaultOptions?: boolean;
}

export const ShipmentNonLCCApproversSelect: FC<ShipmentNonLCCApproversSelectProps> = ({
  placeholder = i18n.t('translation:default.fields.nonLCCApprover.placeholder'),
  label = i18n.t('translation:default.fields.nonLCCApprover.label'),
  rules = [],
  name,
  editMode,
  margin,
  tooltip = false,
  disableValidation = false,
  onChange,
}) => {
  const { selectedCompany } = useSelector((state: RootState) => state.auth);
  const { data: options = [], isLoading } = useGetNonLCCApprovers({ customerKey: selectedCompany?.companyId });

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      rules={rules}
      name={name}
      editMode={editMode}
      margin={margin}
      tooltip={tooltip}
      disableValidation={disableValidation}
      onChange={onChange}
    />
  );
};
